<section>
  <div class="form-register">
    <form [formGroup]="formSubrentalEntryDetail">
      <div class="row p-1">
        <div class="col-lg-2 col-md-6 col-sm-6 col-12">
          <app-custom-select formControlName="storeId" [labelText]="'Bodega'" [list]="listStores" [required]="true"
            [recovery]="true" (onChangeSelect)="getStore($event, true)"></app-custom-select>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
            [required]="true" [recovery]="true" [showExtraButton]="true" [titleExtraButton]="'Seleccionar Artículo'"
            [iconExtraButton]="'pi pi-external-link'" (clickExtraButton)="openArticleSelectionModal()"
            (onChangeSelect)="getArticle($event, true)"></app-custom-autocomplete>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"
            (onChangeNumber)="calculateValues()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unitario'"
            (onChangeNumber)="calculateValues()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="totalValue" [disabled]="true"
            [labelText]="'Vr.Total'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 col-12 d-flex">
          <div class="d-flex align-items-end justify-content-end  gap-2 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>